import React from 'react';
import { ConfigProvider, ThemeConfig } from 'antd';

export const defaultTheme: ThemeConfig = {
    cssVar: true,
    token: {
        fontFamily: 'Inter, Lato, sans-serif',
        colorText: '#344054',
        colorPrimary: '#0C6FF3',
        fontSize: 14,
    },
    components: {
        Layout: {
            headerHeight: 72,
            headerPadding: '12px 24px',
        },
        Input: {
            controlHeight: 36,
            borderRadius: 8,
            borderRadiusLG: 8,
            colorErrorText: '#344054',
        },
        InputNumber: {
            controlHeight: 36,
            borderRadius: 8,
        },
        Form: {
            itemMarginBottom: 0,
        },
        Button: {
            controlHeight: 36,
            borderRadius: 8,
        },
        Spin: {
            dotSizeLG: 48,
        },
        Steps: {
            iconFontSize: 16,
            controlItemBgActive: '#1677ff',
            fontSize: 12,
        },
        Table: {
            headerBg: '#E7F1FE',
            cellPaddingBlock: 18,
            stickyScrollBarBg: 'none',
        },
        Avatar: {
            colorTextLightSolid: '#475467',
        },
        DatePicker: {
            controlHeight: 36,
            borderRadius: 8,
        },
        Select: {
            controlHeight: 36,
            borderRadius: 8,
        },
        Segmented: {
            itemSelectedBg: '#E7F1FE',
            itemHoverColor: '#084CA5',
            trackPadding: 6,
            borderRadius: 8,
            itemSelectedColor: '#084CA5',
            trackBg: '#FFF',
        },
        Collapse: {
            headerBg: 'transparent',
            contentBg: '#FFF',
            colorBorder: 'transparent'
        },
        Tag: {
            borderRadiusSM: 12,
        },
        Slider: {
            trackBg: '#0C6FF3',
            handleColor: '#0C6FF3',
            trackHoverBg: '#0C6FF3',
            handleSize: 12,
            handleSizeHover: 15
        },
        Badge: {
            statusSize: 12,
        },
        Card: {
            colorBorderSecondary: '#d9d9d9',
        },
        Radio: {
            controlHeight: 36,
        },
        Switch: {
            controlHeight: 36,
        },

    },
};

export function ThemeProvider(props: React.PropsWithChildren<unknown>) {
    return (
        <ConfigProvider theme={defaultTheme}>{props.children}</ConfigProvider>
    );
}
